import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'connected-react-router';
import { setImportSelectedTab } from 'store/actions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import { Constants } from 'utilities/constants';
import { importModuleStateSelector } from 'store/selectors';

const ImportNav = ({ classes, push, location, pages, setImportSelectedTab, importLoadingOverlayState, moduleName }) => {

  useEffect(() => {
    console.log(location)
    if (pages.some(page => page.route === location.pathname)) { // validate path, the user may type in the wrong route
      const pathParts = location.pathname.split('/');
      const _path = pathParts[pathParts.length - 1];
      setImportSelectedTab(moduleName, _path);
    } else {
      console.log('bad import route specified')
    }
  }, [location]);

  const handleTabClick = route => {
    if (route && location.pathname !== route) {           // only redirect if path changes
      const pathParts = location.pathname.split('/');
      const _path = pathParts[pathParts.length - 1];
      setImportSelectedTab(moduleName, _path);
      push(route);
    }
  }

  return (
    <Paper square className={classes.container} >
      <List disablePadding>
        {pages.map(page => {
          return (
            <ListItem
              key={page.route}
              button
              classes={{ root: classes.navListItem, selected: classes.selected }}
              selected={location.pathname === page.route}
              onClick={e => handleTabClick(page.route)}
              disabled={importLoadingOverlayState?.isLoading}
            >
              <Tooltip title={page.title} placement='bottom' classes={{ tooltip: classes.lightTooltip }}>
                <ListItemIcon className={classes.icon}>
                  {page.icon ?? null}
                </ListItemIcon>
              </Tooltip>
            </ListItem>
          )
        })}
      </List>
    </Paper>
  )
};

const styles = theme => ({
  container: {
    display: 'flex',
    backgroundColor: '#464646',
    width: 48
  },
  navListItem: {
    padding: theme.spacing(1.5),
  },
  icon: {
    fontSize: 30,
    color: '#e6e6e6', //'#bfbfbf',
    marginRight: 0,
    minWidth: 'unset'
  },
  selected: {
    backgroundColor: `${theme.palette.secondary.main} !important`
  },
  lightTooltip: {
    background: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
});

const mapStateToProps = state => {
  const underwriteState = importModuleStateSelector(state, Constants.Module.UNDERWRITE);
  return {
    importLoadingOverlayState: underwriteState.importLoadingOverlayState, // probably is wrong because it does not take in consideration explore module
  }
}
const mapDispatchToProps = dispatch => {
  return {
    push: route => dispatch(push(route)),
    setImportSelectedTab: (moduleName, importSelectedTab) => dispatch(setImportSelectedTab({ moduleName, importSelectedTab }))
  }
};
export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ImportNav);
